import { ModalToggle, MultiplePanelDelete } from './style';
import Redo from '../RedoBtn';
import ActionStrip from 'components/ModeStrip/Strip';
import { setDeleteArrayMode, setDeleteIndividualPanelsMode, setTempPanelsGroup, togglePanelModal, undoPanelState } from 'store/slices/PanelSlice';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from 'store';
import Button from 'components/Basic/Button';
import UndoButton from '../UndoBtn';

export default function DeletePanelStrip(){

	const dispatch = useDispatch();
	const { deletedPanels, panelHistory , deleteIndividualPanelMode, enableAddPanel, currentIndex , deleteArrayMode} 
		= useSelector((state: RootState) => state.panelSlice.data);
	const panelMode = (deleteIndividualPanelMode || enableAddPanel) && !!( deletedPanels?.length) || panelHistory.length > 0;

	const shouldDisable = (panelMode && currentIndex <= 0);

	return (
		<ActionStrip
			action='Delete Panel'
			icon= {
				<svg width="19.5" height="21.5" viewBox="0 0 22 24" fill="none" xmlns="http://www.w3.org/2000/svg">
					<path d="M7.03074 22.6371H0.945312V1H17.1731V7.76159" 
						stroke="var(--defaultIconColor)" strokeWidth="1.69284" strokeLinecap="round" strokeLinejoin="round"/>
					<path d="M10.5 12.8V23H19.5V12.8H10.5Z" stroke="var(--defaultIconColor)" strokeWidth="1.69" strokeLinejoin="round"/>
					<path d="M13.8 15.8V19.7M16.2 15.8V19.7M9 12.8H21" 
						stroke="var(--defaultIconColor)" strokeWidth="1.69" strokeLinecap="round" strokeLinejoin="round"/>
					<path d="M11.6016 12.8L12.5883 10H17.4347L18.4016 12.8H11.6016Z" 
						stroke="var(--defaultIconColor)" strokeWidth="1.69" strokeLinejoin="round"/>
				</svg>
			}
		>
			<MultiplePanelDelete>
				<span>Delete Array </span>
				<ModalToggle>
					<div className='switchButton bg-transparent'>
						<div className="toggle-button-cover">
							<div className="button-cover">
								<div className="button b2" id="button-13">
									<input
										checked={deleteArrayMode} 
										type="checkbox"
										className="checkbox"
										onChange={(e) => 
											dispatch(setDeleteArrayMode({ enabled: e.target.checked }))
										}
									/>
									<div className="knobs">
										<span></span>
									</div>
									<div className="layer"></div>
								</div>
							</div>
						</div>
					</div>
				</ModalToggle>
			</MultiplePanelDelete>
			<UndoButton/>
			<Redo />
		
		</ActionStrip>
		
	);
}